import React from 'react';
import styles from '../ReportCard.module.scss';

/**
 * Компонент строки поиска с кнопкой «Очистить».
 */
const SearchBar = ({ value, onChange, onClear, placeholder, onKeyDown }) => (
  <div style={{ marginBottom: 12, marginTop: 12, display: 'flex', gap: '12px', alignItems: 'center', flexShrink: 0 }}>
    <input
      type="text"
      placeholder={placeholder || 'Поиск...'}
      value={value}
      onChange={e => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      style={{
        padding: '10px 12px',
        flex: 1,
        maxWidth: '500px',
        borderRadius: 6,
        border: '1px solid #dee2e6',
        fontSize: '14px',
        outline: 'none',
        transition: 'border-color 0.2s ease',
      }}
      onFocus={e => (e.target.style.borderColor = '#0d6efd')}
      onBlur={e => (e.target.style.borderColor = '#dee2e6')}
    />
    {value && (
      <button
        onClick={onClear}
        style={{
          padding: '10px 16px',
          borderRadius: 6,
          border: '1px solid #dee2e6',
          background: '#fff',
          cursor: 'pointer',
          fontSize: '14px',
          color: '#495057',
          fontWeight: '500',
          transition: 'all 0.2s ease',
          whiteSpace: 'nowrap',
        }}
        onMouseOver={e => { e.target.style.background = '#f8f9fa'; e.target.style.borderColor = '#adb5bd'; }}
        onMouseOut={e => { e.target.style.background = '#fff'; e.target.style.borderColor = '#dee2e6'; }}
      >
        Очистить
      </button>
    )}
  </div>
);

export default React.memo(SearchBar);
